module.exports = __webpack_public_path__ + "static/media/yes.b6d488a5.mp3";